import { LuX } from 'react-icons/lu'

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

export function CloseButton({
  className,
  ...props
}: React.ComponentProps<typeof LuX>) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <LuX
          role="button"
          className={cn('cursor-pointer text-xl hover:opacity-80', className)}
          {...props}
        />
      </TooltipTrigger>

      <TooltipContent>Close</TooltipContent>
    </Tooltip>
  )
}
